module.exports = __webpack_public_path__ + "static/media/WhatWeDo_Conference.c5e3b858.jpg";